import styled from 'styled-components';

interface OptionTooltipProps {
  text: string[];
  setTooltip: () => void;
}

const OptionTooltip = ({ text, setTooltip }: OptionTooltipProps) => {
  return (
    <Container>
      <TextBox>
        {text.map((t, index) => (
          <div key={index}>{t}</div>
        ))}
      </TextBox>
      <img
        src="/assets/images/close/close-dark-gray.svg"
        alt="툴팁 닫기"
        onClick={() => setTooltip()}
      />
    </Container>
  );
};

export default OptionTooltip;

const Container = styled.div`
  position: absolute;
  top: 25px;
  left: -10px;
  width: 320px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  box-shadow:
    0px 6px 12px 0px rgba(0, 0, 0, 0.12),
    0px 4px 8px 0px rgba(0, 0, 0, 0.08),
    0px 0px 4px 0px rgba(0, 0, 0, 0.08);
  z-index: 100;
  font-size: 14px;
  font-weight: 400;
  color: #616161;

  img {
    cursor: pointer;
  }
`;

const TextBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  white-space: pre-line;
`;
